<template>
  <card class="w-100">
    <el-form class="form-horizontal" :model="account" :rules="rules" ref="account" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item v-if="!$route.params.forceRoleCode" label="권한" prop="roleCode">
            <el-select v-model="account.roleCode" :disabled="readonly" @change="changeRoleCode">
              <el-option
                v-for="item in this.$store.state.common.roles"
                :key="item.roleCode"
                :label="item.roleName"
                :value="item.roleCode">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-if="isChangeCompany" label="업체 정보 변경">
            <el-switch v-model="selectCompany" @change="switchChangeCompany"/>
          </el-form-item> -->
          <el-form-item v-if="selectCompany" label="업체" prop="companySeq">
            <el-select v-model="account.companySeq" filterable>
              <el-option
                v-for="item in this.$store.state.settingsCompany.company"
                :key="item.companySeq"
                :label="item.companyName"
                :value="item.companySeq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="selectStore" label="점포" prop="companySeq">
            <el-select v-model="account.companySeq" filterable>
              <el-option
                v-for="item in this.$store.state.store.stores"
                :key="item.storeSeq"
                :label="item.storeName"
                :value="item.storeSeq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="newCompany" label="회사명" prop="companyName">
            <el-input v-model="account.companyName" :disabled="checkAuth($store.state.account.roleCode, 'ADVERTISER:AGENT:BUILDER')"/>
          </el-form-item>
          <el-form-item :label="idLabel" prop="userId">
            <el-input v-model="account.userId" :disabled="checkAuth($store.state.account.roleCode, 'ADVERTISER:AGENT:BUILDER')"/>
          </el-form-item>
          <el-form-item label="비밀번호 변경" v-if="readonly">
            <el-switch v-model="changePassword"></el-switch>
          </el-form-item>
          <el-form-item label="비밀번호" prop="password" v-if="changePassword || type === 'new'">
            <el-input  show-password v-model="account.password"></el-input>
          </el-form-item>
          <el-form-item label="비밀번호 확인" prop="passwordRetry" v-if="changePassword || type === 'new'">
            <el-input  show-password v-model="account.passwordRetry"></el-input>
          </el-form-item>
          <el-form-item label="이름" prop="userName">
            <el-input v-model="account.userName"></el-input>
          </el-form-item>
          <el-form-item label="이메일" v-if="this.account.masterYn === 'Y'">
            <el-input v-model="account.email"></el-input>
          </el-form-item>
          <el-form-item label="연락처">
            <el-input v-model="account.phone1"></el-input>
          </el-form-item>

          <!-- <el-form-item label="연락처">
            <tel-input v-model="account.phone1" ></tel-input>
          </el-form-item> -->

          <el-form-item label="부서" v-if="this.account.masterYn === 'N'">
            <el-input v-model="account.department" ></el-input>
          </el-form-item>
          <el-form-item label="상태" v-if="readonly && !this.myInfo">
            <el-select v-model="account.status">
              <el-option
                label="정상"
                value="OK"></el-option>
              <el-option
                label="삭제"
                value="REMOVE"></el-option>
                <el-option v-if="/AGENT|ADVERTISER/.test(account.roleCode) && account.masterYn == 'N'"
                label="승인대기중"
                value="READY"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="card-footer text-right">
        <el-button type="primary" v-if="type === 'new'" @click="submitForm('account')">등록</el-button>
        <el-button type="primary" v-if="type === 'edit'" @click="submitForm('account')">수정</el-button>
        <el-button v-if="type === 'new' && !$route.params.forceRoleCode" @click.prevent="resetForm('account')">리셋</el-button>
        <el-button v-if="!this.myInfo" @click.prevent="historyBack">취소</el-button>
      </div>
    </el-form>
  </card>
</template>

<script>
    import Vue from 'vue'
    import {Select, DatePicker, Form, FormItem, Button, Option, Input, Row, Col, Table, TableColumn, Switch} from 'element-ui';
    import AccountsProxy from "@/proxies/AccountsProxy";
    import TelInput from '@/components/Pages/Views/Common/TelInput.vue'

    Vue.use(Table);
    Vue.use(TableColumn);

    export default {
        name: "SettingsAccountRegistration",
        components: {
            [DatePicker.name]: DatePicker,
            elSelect: Select,
            elForm: Form,
            elFormItem: FormItem,
            elButton: Button,
            elOption: Option,
            elInput: Input,
            elRow: Row,
            elCol: Col,
            elSwitch: Switch,
            TelInput,
        },
        created: function () {

            this.historyParams = {...this.$route.params}

            if(this.$route.params.userId !== undefined) {
                this.type = "edit";
                this.account.userId = this.$route.params.userId;
                if(this.$route.query.myInfo !== undefined) this.myInfo = this.$route.query.myInfo;
                this.$store.dispatch('common/setMenuTitle', "계정수정");
                this.readonly = true;

                new AccountsProxy()
                    .find(this.account.userId)
                    .then((response) => {
                        this.account = {...response.user}
                        this.account.oldUserId = this.account.userId
                        this.changeRoleCode(this.account.roleCode, this.account.companySeq);
                    })
            } else {
                this.type = "new";
                this.$store.dispatch('common/setMenuTitle', "계정등록");
            }

            let roleCode = this.$route.params.forceRoleCode || this.$route.params.defaultRoleCode
            if(roleCode) {
              this.account.roleCode = roleCode
              this.changeRoleCode(this.account.roleCode)
              const roleName = this.$store.state.common.roles.find(item=>item.roleCode === this.account.roleCode).roleName
              this.$store.dispatch('common/setMenuTitle', roleName + " 계정" + (this.$route.params.userId !== undefined ? "수정" : "등록"))
            }

            this.$store.dispatch('common/roleFindAll');
            this.$store.dispatch('store/findAll'); // 점포 리스트
        },
        methods: {
            switchChangeCompany(value) {
                // this.newCompany = !value;
            },
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            changeRoleCode(value, companySeq) {
                console.log({value, companySeq})
                if(this.newCompanyRoleCode.indexOf(value) >= 0) {
                    // 업체리스트 조회
                    this.$store.dispatch('settingsCompany/findAll', {roleCode : value === 'AGENT' ? 'ADVERTISER' : value, rows : 100000});
                    this.selectStore = false;
                    this.newCompany = true;
                } else if(this.storeRoleCode.indexOf(value) >= 0) {
                    // 매장리스트 조회
                    this.$store.dispatch('settingsCompany/findAll', {roleCode : value, rows : 100000});
                    this.selectStore = true;
                    this.newCompany = false;
                } else {
                    // 업체 입력 필요없음
                    this.selectStore = false;
                    this.newCompany = false;
                }
                if("ADVERTISER" === value && this.account.masterYn === 'Y') {
                  this.idLabel = "사업자등록번호";
                } else {
                  this.idLabel = "아이디";
                }
                this.selectCompany = false;
                // 광고주 추가하는 경우 기존 업체 선택 가능하도록
                if((value === "ADVERTISER" || value === "AGENT") && this.type === "new") {
                    this.isChangeCompany = true;
                } else {
                    this.isChangeCompany = false;
                }
                if(companySeq === undefined) {
                    this.account.companySeq = '';
                } else {
                    // 회원정보 수정인 경우 처리
                    this.account.companySeq = companySeq;
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.type === "new") {
                            if(confirm("등록하시겠습니까?")) {
                                this.account.status = "OK";
                                this.account.licenseNumber = this.account.userId;
                                this.account.changeCompany = this.selectCompany;
                                this.$store.dispatch("settingsAccount/createUser", this.account)
                                .then(response=>{
                                    if(response.header.returnCode === "OK") {
                                      alert('등록 되었습니다.')        
                                      this.$router.push({
                                        name: this.$route.params.returnName, // 'SettingsAccount',
                                      });
                                    } else {
                                      alert(response.header.resultMessages);
                                    }
                                })

                            }
                        } else {
                            if(confirm("수정하시겠습니까?")) {
                                this.account.regDate = null;
                                const proxy = new AccountsProxy()
                                let promise
                                if(this.account.masterYn === 'Y') {
                                    promise = proxy.update(this.account.userId, this.account)
                                } else {
                                  // 담당자 계정 수정 저장
                                  promise = proxy.updateSubUser(this.account)
                                }

                                    promise.then((response) => {
                                        if(response.header.returnCode === "OK") {
                                            if(this.myInfo) {
                                                alert("수정되었습니다.");
                                            } else {
                                              Vue.router.push({
                                                name: this.$route.params.returnName, // 'SettingsAccount',
                                                params: this.historyParams,
                                              });
                                            }
                                        } else {
                                            alert(response.header.resultMessages);
                                        }

                                    })
                            }
                        }
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();

                this.changeRoleCode("");

            },
            historyBack() {
              Vue.router.push({
                name: this.$route.params.returnName, // 'SettingsAccount',
                params: this.historyParams,
              });
            },
          checkAuth(roleCode, targetRoles) {
            return Vue.checkAuth(roleCode, targetRoles);
          },
        },
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === '' || value.length < 2) {
                    callback(new Error('비밀번호를 2자리 이상 입력하세요.'));
                } else if(value && !/^(?=.*?[#?!@$ %^&*-]).{6,}$/.test(value)) {                    
                    callback(new Error('특수 문자 포함 6자 이상 입력하세요.'));
                } else {
                    if (this.account.passwordRetry !== '') {
                        this.$refs.account.validateField('checkPass');
                    }
                    callback();
                }
            };
            let validatePass2 = (rule, value, callback) => {
                if (value === '' || value.length < 2) {
                    callback(new Error('비밀번호를 2자리 이상 입력하세요.'));
                } else if (value !== this.account.password) {
                    callback(new Error('비밀번호가 같아야 합니다.'));
                } else {
                    callback();
                }
            };
            let companyName = (rule, value, callback) => {
              if(this.account.companySeq === "0" && value === '') {
                  callback(new Error('회사명을 입력하세요.'));
              } else {
                  callback();
              }
            };
            let validateId = (rule, value, callback) => {
                if(this.type === "new") {
                    if (value === '' || value.length < 3) {
                        callback(new Error('아이디를 3자리 이상 입력하세요.'));
                    } else {
                        new AccountsProxy()
                            .find(value)
                            .then((response) => {
                                if (response.header.returnCode === "DUPLICATE_USER_ID") {
                                    callback();
                                } else {
                                    callback(new Error('이미 사용중인 ' + this.idLabel + '입니다. 다른 ' + this.idLabel + '를 입력하세요.'));
                                }
                            });
                    }
                } else {
                    callback();
                }
            };
            return {
                perPage: 10,
                myInfo: false,
                isChangeCompany: false,  // 업체변경 switch 노출여부
                selectCompany: false,   // 업체 선택 노출여부
                newCompanyRoleCode: ["BUILDER", "AGENT", "ADVERTISER"],
                storeRoleCode: ["EMART"],
                newCompany: false,  // 업체추가가 필요한 권한여부
                type: '',     // edit:수정 , new:추가
                readonly: false,  // 수정화면에서 읽기전용필드 설정용
                changePassword: false,  // 수정화면에서 비밀번호 수정여부
                selectStore: false,   // 매장선택 필드 노출여부
                idLabel: "아이디",
                account: {
                    oldUserId: '',
                    userId: '',
                    userName: '',
                    roleCode: '',
                    licenseNumber: '',
                    companyName: '',
                    password: '',
                    passwordRetry: '',
                    email: '',
                    phone1: '',
                    companySeq: '',
                    storeSeq: '',
                    status: '',
                    masterYn: 'Y',
                    changeCompany: false,
                },
                rules: {
                    roleCode: [
                        { required: true, message: '권한을 선택하세요.', trigger: 'change' }
                    ],
                    companySeq: [
                        { required: true, message: '회사를 선택하세요.', trigger: 'change' }
                    ],
                    storeSeq: [
                        { required: true, message: '점포를 선택하거나 추가 후 등록바랍니다.', trigger: 'change' }
                    ],
                    companyName: [
                        { required: true, validator: companyName, trigger: 'blur' }
                    ],
                    userName: [
                        { required: true, message: '이름을 입력하세요.', trigger: 'change' }
                    ],
                    userId: [
                        { required: true, validator: validateId, trigger: 'blur' }
                    ],
                    password: [
                        { required: true, validator: validatePass, trigger: 'blur' }
                    ],
                    passwordRetry: [
                        { required: true, validator: validatePass2, trigger: 'blur' }
                    ],
                }
            }
        },

    }
</script>

<style scoped>
.el-form-item {
    margin-bottom: 22px !important;
}
</style>